// Login page — magic-link request form.
// Only kimi@marketdwellings.com is allowlisted via public.users + RLS.

import { useState, type FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useAuth } from '@/auth/AuthProvider';

export function LoginPage() {
  const { signInWithEmail } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg(null);
    const { error } = await signInWithEmail(email.trim());
    if (error) {
      setStatus('error');
      setErrorMsg(error);
      return;
    }
    setStatus('sent');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Unified Inbox</CardTitle>
          <CardDescription>Sign in with your Market Dwellings email.</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@marketdwellings.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
                disabled={status === 'sending' || status === 'sent'}
              />
            </div>
            {status === 'sent' && (
              <p className="text-sm text-muted-foreground">
                Magic link sent. Check your inbox.
              </p>
            )}
            {status === 'error' && errorMsg && (
              <p className="text-sm text-destructive">{errorMsg}</p>
            )}
          </CardContent>
          <CardFooter>
            <Button
              type="submit"
              className="w-full"
              disabled={status === 'sending' || status === 'sent' || !email}
            >
              {status === 'sending' ? 'Sending…' : status === 'sent' ? 'Sent' : 'Send magic link'}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
